import { render, staticRenderFns } from "./chart1.vue?vue&type=template&id=47624a9a&scoped=true&"
import script from "./chart1.vue?vue&type=script&lang=js&"
export * from "./chart1.vue?vue&type=script&lang=js&"
import style0 from "./chart1.vue?vue&type=style&index=0&id=47624a9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47624a9a",
  null
  
)

export default component.exports